import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import type { ViewMode } from '../_types/types';
interface PolicyContentSkeletonProps {
  viewMode: ViewMode;
}
const HeaderSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-53 items-center justify-between px-20 pb-20"><div className="flex items-center gap-8"><Skeleton className="h-20 w-60 rounded-small" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const ListSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="flex min-h-[calc(100vh-330px)] flex-col gap-16 px-20 pb-40">{[1, 2, 3].map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const TimelineSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [{
      id: "past",
      isExpanded: false
    }, {
      id: "past2",
      isExpanded: false
    }, {
      id: "current",
      isExpanded: true
    }, {
      id: "future",
      isExpanded: false
    }];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const sections = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex min-h-[calc(100vh-270px)] flex-col gap-12 px-20 pb-40">{sections.map((section, sectionIndex) => {
        const isLast = sectionIndex === sections.length - 1;
        const isCurrent = section.id === "current";
        return <div key={section.id} className="relative flex items-start gap-10 animate-in fade-in-0" style={{
          animationDelay: `${sectionIndex * 100}ms`,
          animationFillMode: "both"
        }}>{!isLast && <div className={cn("absolute left-5 top-36 z-0 h-[calc(100%+20px)] w-2", isCurrent ? "bg-gradient-to-b from-B-500 to-Gray-300" : "bg-Gray-300")} />}<div className="absolute left-0 top-30 z-10"><div className={cn("size-12 rounded-pill", isCurrent ? "bg-B-500" : "bg-Gray-300")} /></div><div className="flex-1 pl-28">{section.isExpanded ? <div className={cn("overflow-hidden rounded-medium border bg-Gray-white", isCurrent ? "border-B-500" : "border-Gray-400")}><div className={cn("flex h-[72.2px] items-center justify-between px-20 py-16", isCurrent ? "bg-B-25" : "bg-Gray-50")}><div className="flex flex-col items-start gap-6"><Skeleton className="w-150 rounded-small" typo="body4" /><Skeleton className="w-100 rounded-small" typo="caption1" /></div><div className="flex items-center gap-8"><Skeleton className="w-40 rounded-small" typo="body4" /><Skeleton className="size-12 rounded-pill" /></div></div><div className="flex flex-col">{[1, 2, 3].map(_temp2)}</div></div> : <div className="flex h-[74.2px] items-center justify-between rounded-medium bg-Gray-white px-20 py-16"><div className="flex flex-col items-start gap-6"><Skeleton className="w-150 rounded-small" typo="body4" /><Skeleton className="w-100 rounded-small" typo="caption1" /></div><div className="flex items-center gap-8"><Skeleton className="w-40 rounded-small" typo="body4" /><Skeleton className="size-12 rounded-pill" /></div></div>}</div></div>;
      })}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const PolicyContentSkeleton = t0 => {
  const $ = _c(2);
  const {
    viewMode
  } = t0;
  if (viewMode === "timeline") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <TimelineSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><HeaderSkeleton /><ListSkeleton /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(index) {
  return <li key={index} className="animate-in fade-in-0" style={{
    animationDelay: `${index * 100}ms`,
    animationFillMode: "both"
  }}><article className="flex h-[194.2px] flex-col justify-between rounded-xxlarge bg-Gray-white p-24"><div className="flex items-start justify-between"><div className="flex flex-1 flex-col gap-6"><div className="flex items-center gap-4"><Skeleton className="size-20 rounded-pill" /><Skeleton className="w-70 rounded-small" typo="caption1" /></div><Skeleton className="h-38 w-full rounded-small" /></div><div className="flex flex-col items-center gap-2"><Skeleton className="size-20 rounded-small" /><Skeleton className="w-16 rounded-small" typo="caption1" /></div></div><div className="flex flex-col gap-16"><div className="rounded-small bg-Gray-25 px-14 py-12"><div className="flex w-full items-start gap-4"><div className="flex shrink-0 items-center gap-2"><Skeleton className="size-12 rounded-small" /><Skeleton className="h-12 w-40 rounded-small" /></div><Skeleton className="h-24 flex-1 rounded-small" /></div></div><div className="flex items-center gap-12"><Skeleton className="w-70 rounded-small" typo="caption1" /><Skeleton className="ml-auto w-50 rounded-small" typo="caption1" /></div></div></article></li>;
}
function _temp2(cardIndex) {
  return <div key={cardIndex} className="p-24 pb-0 animate-in fade-in-0" style={{
    animationDelay: `${cardIndex * 50}ms`,
    animationFillMode: "both"
  }}><div className="flex flex-col gap-12 border-b border-Gray-300 bg-Gray-white"><div className="flex items-start justify-between gap-24"><div className="flex min-w-0 flex-1 flex-col gap-6"><div className="flex items-center gap-4"><Skeleton className="size-24 rounded-pill" /><Skeleton className="w-70 rounded-small" typo="caption1" /></div><Skeleton className="h-19 w-full rounded-small" /></div><div className="flex shrink-0 flex-col items-center gap-2"><Skeleton className="size-20 rounded-small" /><Skeleton className="w-16 rounded-small" typo="caption1" /></div></div><div className="flex flex-col gap-12 pb-24"><div className="rounded-small bg-Gray-25 px-14 py-12"><div className="flex w-full items-start gap-4"><div className="flex shrink-0 items-center gap-2"><Skeleton className="size-12 rounded-small" /><Skeleton className="h-12 w-40 rounded-small" /></div><Skeleton className="h-24 flex-1 rounded-small" /></div></div><div className="flex items-center gap-8"><Skeleton className="w-70 rounded-small" typo="caption1" /><Skeleton className="ml-auto w-50 rounded-small" typo="caption1" /></div></div></div></div>;
}